export const reverseStr = (str: string) => {
  const splitString = str.split("-");

  const reverseArray = splitString.reverse();

  const joinArray = reverseArray.join("-");

  return joinArray;
};
